import { Project, TFile } from "@brg/api";
import { useProfile } from "@brg/auth";
import { FC, ReactNode, useMemo } from "react";
import { useRouteMatch } from "react-router-dom";
import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam";
import { PersonalChannelCover } from "./PersonalChannelCover";
import { OverflowContainer } from "../styles";
import { AgeRestrictedOverlay, CoverImage } from "../projectCardLayoutNew";
import { DesignerCertCardImage } from "shared/pages/designer/components/tabs/designerDiscountstab";
import { WarholCardCover } from "shared/components/WarholCardCover/WarholCardCover";
import { VoteCollectionCover } from "shared/pages/projectEdit/components/VoteCollectionCover/VoteCollectionCover";
import { ChannelDefaultEmblem } from "shared/pages/exploreHseContextsNew/components/ChannelDefaultEmblem";
import { LMSModuleCover } from "shared/components/LMSModuleCover/LMSModuleCover";
import { isPersonalOrDefaultChannel } from "shared/helpers/teamsStatus";
import { isFtblMatchProject } from "../../../constants/ftblProjectTypes";
import FtblCoverImage from "./FtblCoverImage/FtblCoverImage";
import { WarholCardCoverFixed } from "shared/components/WarholCardCoverFixed/WarholCardCoverFixed";

export const ProjectCover: FC<{ 
    team: ComputedTeam, 
    project: Project<'Local'> | Project<'Global'>, 
    title: ReactNode,
    point: ReactNode,
    isLoading?: boolean,
    card?: any,
    isLMS?: boolean,
    LMSDiscipline?: any,
    isCert?: boolean,
    needLMSTeamCover?: boolean,
    isLargeProject?: boolean,
    isLMSProject?: boolean,
    coverTitle: ReactNode,
    isSquare?: boolean,
    isTeam?: boolean,
    isBookChapter?: boolean,
    titleImages?: TFile[],
    teamWithoutImage?: boolean,
    isCollectionVote?: boolean
    lowOpacity?: boolean
}> = ({
    team, 
    project, 
    title,
    point,
    card,
    isLMS,
    isCert,
    isLoading,
    isLargeProject,
    isBookChapter,
    needLMSTeamCover,
    isLMSProject,
    coverTitle,
    titleImages,
    isTeam,
    isSquare,
    LMSDiscipline,
    teamWithoutImage,
    isCollectionVote,
    lowOpacity
}) => {
    const profile = useProfile();
    const isFeed = useRouteMatch('/feed');

    const isProjectFromCard = useMemo(() => {
        return project?.isAdaptiveCard && project?.projectType === 'fixed-ratio-small'
    }, [project])

    const coverComponent = useMemo(() => (
        <OverflowContainer isAdaptiveCard={project?.isAdaptiveCard} lowOpacity={lowOpacity}>
        {project?.isAgeRestricted && <AgeRestrictedOverlay />}
        {/*@ts-ignore*/}
        {!isLoading && (isCert && !!card ? (
            <DesignerCertCardImage card={card} />
        ) : isProjectFromCard ? (
            <WarholCardCoverFixed project={project} />
        ) : project?.isAdaptiveCard ? (
            <WarholCardCover project={project} />
        ) : isCollectionVote ? (
            <VoteCollectionCover project={project} />
        ) : (teamWithoutImage && !isLMS) ? (
            <ChannelDefaultEmblem team={team} />
        ) : (isLMSProject || needLMSTeamCover) ? (
            <LMSModuleCover project={project} title={coverTitle || title} discipline={LMSDiscipline} />
        ) : (isFtblMatchProject(project?.projectType)) ? (
            <FtblCoverImage project={project} />
        )  : (
            <CoverImage
            isSquare={isSquare}
            showEmptyPlaceholder={!isBookChapter}
            showDefaultPlaceholder={isBookChapter}
            files={titleImages}
            isTeam={isTeam}
            isLargeProject={isLargeProject}
            alt={project?.title}
            />
        ))}
        {point}
        </OverflowContainer>
    ) , [
        project,
        team,
        isLoading,
        isCert,
        card,
        isProjectFromCard,
        isCollectionVote,
        teamWithoutImage,
        isLMS,
        isLMSProject,
        needLMSTeamCover,
        coverTitle,
        title,
        LMSDiscipline,
        isSquare,
        isBookChapter,
        titleImages,
        isTeam,
        isLargeProject,
        point,
        lowOpacity
    ])
    
    if (isPersonalOrDefaultChannel(team, profile) && isFeed) {
        return (
            <PersonalChannelCover
                team={team}
                title={title}
                cover={coverComponent}
            />
        )
    }


    return coverComponent
}import { Project, TFile } from "@brg/api";
import { useProfile } from "@brg/auth";
import { FC, ReactNode, useMemo } from "react";
import { useRouteMatch } from "react-router-dom";
import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam";
import { PersonalChannelCover } from "./PersonalChannelCover";
import { OverflowContainer } from "../styles";
import { AgeRestrictedOverlay, CoverImage } from "../projectCardLayoutNew";
import { DesignerCertCardImage } from "shared/pages/designer/components/tabs/designerDiscountstab";
import { WarholCardCover } from "shared/components/WarholCardCover/WarholCardCover";
import { VoteCollectionCover } from "shared/pages/projectEdit/components/VoteCollectionCover/VoteCollectionCover";
import { ChannelDefaultEmblem } from "shared/pages/exploreHseContextsNew/components/ChannelDefaultEmblem";
import { LMSModuleCover } from "shared/components/LMSModuleCover/LMSModuleCover";
import { isPersonalOrDefaultChannel } from "shared/helpers/teamsStatus";
import { isFtblMatchProject } from "../../../constants/ftblProjectTypes";
import FtblCoverImage from "./FtblCoverImage/FtblCoverImage";
import { WarholCardCoverFixed } from "shared/components/WarholCardCoverFixed/WarholCardCoverFixed";

export const ProjectCover: FC<{ 
    team: ComputedTeam, 
    project: Project<'Local'> | Project<'Global'>, 
    title: ReactNode,
    point: ReactNode,
    isLoading?: boolean,
    card?: any,
    isLMS?: boolean,
    LMSDiscipline?: any,
    isCert?: boolean,
    needLMSTeamCover?: boolean,
    isLargeProject?: boolean,
    isLMSProject?: boolean,
    coverTitle: ReactNode,
    isSquare?: boolean,
    isTeam?: boolean,
    isBookChapter?: boolean,
    titleImages?: TFile[],
    teamWithoutImage?: boolean,
    isCollectionVote?: boolean
    lowOpacity?: boolean
}> = ({
    team, 
    project, 
    title,
    point,
    card,
    isLMS,
    isCert,
    isLoading,
    isLargeProject,
    isBookChapter,
    needLMSTeamCover,
    isLMSProject,
    coverTitle,
    titleImages,
    isTeam,
    isSquare,
    LMSDiscipline,
    teamWithoutImage,
    isCollectionVote,
    lowOpacity
}) => {
    const profile = useProfile();
    const isFeed = useRouteMatch('/feed');

    const isProjectFromCard = useMemo(() => {
        return project?.isAdaptiveCard && project?.projectType === 'fixed-ratio-small'
    }, [project])

    const coverComponent = useMemo(() => (
        <OverflowContainer isAdaptiveCard={project?.isAdaptiveCard} lowOpacity={lowOpacity}>
        {project?.isAgeRestricted && <AgeRestrictedOverlay />}
        {/*@ts-ignore*/}
        {!isLoading && (isCert && !!card ? (
            <DesignerCertCardImage card={card} />
        ) : isProjectFromCard ? (
            <WarholCardCoverFixed project={project} />
        ) : project?.isAdaptiveCard ? (
            <WarholCardCover project={project} />
        ) : isCollectionVote ? (
            <VoteCollectionCover project={project} />
        ) : (teamWithoutImage && !isLMS) ? (
            <ChannelDefaultEmblem team={team} />
        ) : (isLMSProject || needLMSTeamCover) ? (
            <LMSModuleCover project={project} title={coverTitle || title} discipline={LMSDiscipline} />
        ) : (isFtblMatchProject(project?.projectType)) ? (
            <FtblCoverImage project={project} />
        )  : (
            <CoverImage
            isSquare={isSquare}
            showEmptyPlaceholder={!isBookChapter}
            showDefaultPlaceholder={isBookChapter}
            files={titleImages}
            isTeam={isTeam}
            isLargeProject={isLargeProject}
            alt={project?.title}
            />
        ))}
        {point}
        </OverflowContainer>
    ) , [
        project,
        team,
        isLoading,
        isCert,
        card,
        isProjectFromCard,
        isCollectionVote,
        teamWithoutImage,
        isLMS,
        isLMSProject,
        needLMSTeamCover,
        coverTitle,
        title,
        LMSDiscipline,
        isSquare,
        isBookChapter,
        titleImages,
        isTeam,
        isLargeProject,
        point,
        lowOpacity
    ])
    
    if (isPersonalOrDefaultChannel(team, profile) && isFeed) {
        return (
            <PersonalChannelCover
                team={team}
                title={title}
                cover={coverComponent}
            />
        )
    }


    return coverComponent
}